
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30606',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30606",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.55062",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8196",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11649",
  "I18n": "static-7.1645",
  "quartz": "static-1.7261",
  "quartz-config": "static-1.1039",
  "quartz-core": "static-1.6480",
  "react-dlb": "static-1.83",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "reselect": "static-3.8",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.842",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55049",
  "feedback-utils": "static-1.55053",
  "forms-embed-utils-lib": "static-1.4637",
  "forms-utils-lib": "static-1.12902",
  "foundations-assets": "static-1.5047",
  "foundations-components": "static-1.8274",
  "foundations-theming": "static-1.4612",
  "hub-http": "static-1.6393",
  "hubspot-url-utils": "static-1.4132",
  "HubStyle": "static-2.11956",
  "icons": "static-2.665",
  "immutable": "static-2.79",
  "quick-fetch": "static-1.4042",
  "raven": "static-3.5925",
  "react": "static-7.189",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16874",
  "react-select-plus": "static-1.108",
  "react-utils": "static-2.5466",
  "react-virtualized": "static-2.102",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.491",
  "tinymce-plugins": "static-1.57954",
  "transmute": "static-2.85",
  "ui-images": "static-2.1205",
  "UIComponents": "static-3.8595",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3525",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3538",
  "quartz-webpack": "static-1.3485",
  "foundations-theming-specialty": "static-1.2328",
  "property-description-translator": "static-1.4011",
  "HeadJS": "static-2.777",
  "framer-motion": "static-1.75",
  "hs-test-utils-bend-plugin": "static-1.3307",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.225",
  "moment-timezone": "static-5.86",
  "jasmine": "static-4.4497",
  "jasmine-runner": "static-1.6629",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.852",
  "hubspotter-http": "static-1.4776",
  "mobile-manifest-mixins": "static-1.551",
  "module-federation": "static-1.29",
  "quartz-auth": "static-1.936",
  "quartz-head": "static-1.926",
  "quartz-i18n": "static-1.936",
  "quartz-routing": "static-1.691",
  "quartz-test": "static-1.936",
  "quartz-tracking": "static-1.640",
  "trellis-components": "static-1.2300",
  "ui-fonts": "static-1.911",
  "usage-tracker-container": "static-1.7515",
  "usage-tracker-core": "static-1.7375",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.159",
  "conversations-skeleton-state": "static-1.7422",
  "reference-resolvers": "static-1.8349",
  "sanitize-text": "static-1.8319",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10538",
  "sanitize": "static-1.4651",
  "outpost": "static-1.4342",
  "rpc-client-utils": "static-1.4831",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4543",
  "floating-ui": "static-1.60",
  "hs-story-utils": "static-1.9599",
  "react-aria": "static-1.69",
  "react-create-root-preference": "static-1.45",
  "tanstack-table": "static-1.58",
  "trellis-assets": "static-1.2281",
  "bend-plugin-foundations-theming": "static-1.3095",
  "foundations-theming-base": "static-1.3597",
  "stylex": "static-1.37",
  "hs-locale-management": "static-1.206",
  "csstype": "static-1.50",
  "web-vitals": "static-1.9",
  "ai-components-ui-library": "static-1.9400",
  "atom": "static-1.5249",
  "codemirror": "static-5.98",
  "content-assistance-lib": "static-1.8021",
  "ContentUtils": "static-1.68884",
  "data-token-picker": "static-1.16716",
  "file-manager-components": "static-1.24137",
  "FileManagerCore": "static-1.39636",
  "FileManagerLib": "static-1.39777",
  "frontend-preferences-client": "static-1.8101",
  "hub-http-contrib": "static-1.3216",
  "interframe": "static-3.4929",
  "layout-dnd-components": "static-1.12781",
  "layout-dnd-utils": "static-1.11756",
  "property-translator": "static-1.5567",
  "react-codemirror": "static-1.10807",
  "react-colorpicker": "static-2.10381",
  "reference-resolvers-lite": "static-1.8270",
  "rich-text-lib": "static-1.20134",
  "tinymce-data": "static-1.40925",
  "tinymce-themes": "static-1.56810",
  "ui-addon-emoji-picker": "static-1.10057",
  "ui-addon-sales-email": "static-1.5386",
  "ui-brand-identity-lib": "static-1.15925",
  "bender-build-tools": "static-1.3308",
  "hub-http-shared-msw-handlers": "static-1.10395",
  "hubspotter-http-shared-msw-handlers": "static-1.10393",
  "usage-tracker-session-replay": "static-1.5211",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "trellis-theming": "static-1.1122",
  "tanstack-virtual": "static-1.33",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.241",
  "chirp-fetch": "static-1.2061",
  "chatspot-core": "static-1.22193",
  "copilot-toolkit": "static-1.11585",
  "customer-data-objects-ui-components": "static-1.13203",
  "data-fetching-client": "static-1.9832",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4932",
  "ui-addon-video-player": "static-1.8879",
  "ui-coaching-tips": "static-1.29054",
  "usage-tracker": "static-1.7525",
  "cms-field-types": "static-1.4988",
  "content-icons-ui": "static-1.2278",
  "integrations-lib": "static-1.16714",
  "customer-data-objects": "static-1.7853",
  "apollo-dlb": "static-3.86",
  "breeze-engine-lib": "static-1.1347",
  "apollo-link-hub-http": "static-2.4825",
  "apollo-stack-hubspot": "static-3.89",
  "graphql": "static-1.85",
  "immer": "static-1.33",
  "immerable": "static-1.4322",
  "ui-addon-iframeable": "static-1.9248",
  "video-components-external": "static-1.11857",
  "video-data-lib": "static-1.35515",
  "audio-components": "static-1.6176",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29623",
  "FileManagerImages": "static-1.37288",
  "foundations-components-legacy": "static-1.1299",
  "html-to-image": "static-1.57",
  "react-immutable-proptypes": "static-2.8",
  "redux-toolkit": "static-1.7",
  "salesImages": "static-1.529",
  "ui-universal-auth": "static-1.9183",
  "urlinator": "static-1.4705",
  "video-components": "static-1.13859",
  "video-embed": "static-1.36349",
  "ts-schema": "static-1.4205",
  "ContentData": "static-1.68959",
  "layout-data-lib": "static-1.10081",
  "react-dnd-compat": "static-1.4788",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1718",
  "external-options-client-types": "static-1.4251",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7068",
  "hs-promise-utils": "static-1.5767",
  "inbound-db-properties-service-client": "static-1.3971",
  "NamespacedHubStyle": "static-2.9176",
  "growth-onboarding-confetti": "static-1.3236",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11322",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5667",
  "magpie-types": "static-1.5127",
  "simple-logging-lib": "static-1.3223",
  "avatar-components": "static-1.2672",
  "customer-data-ui-utilities": "static-1.9998",
  "growth-onboarding-feedback-components": "static-1.6753",
  "flux-actions": "static-1.352",
  "hubspot-apollo-client": "static-1.5050",
  "integrations-error-boundary-lib": "static-1.14129",
  "integrations-tracking-lib": "static-1.5781",
  "laboratory-lib": "static-3.7325",
  "native-integrations-shared-strings": "static-1.7954",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10435",
  "unified-auth": "static-1.697",
  "breeze-engine-core": "static-1.625",
  "ably": "static-2.2",
  "highlight.js": "static-1.82",
  "navigation-messaging": "static-1.7820",
  "content-media-composition-data-lib": "static-1.12885",
  "content-media-compositions": "static-2.16892",
  "idb-keyval": "static-1.47",
  "media-bridge-lib": "static-1.19230",
  "unified-auth-core-lib": "static-1.979",
  "social-insights-client-types": "static-1.22541",
  "advanced-menus-core": "static-1.15417",
  "advanced-menus-lib": "static-1.12314",
  "ExportDialog": "static-6.10552",
  "ui-memberships-settings-lib": "static-1.34529",
  "conditional-properties-service-client": "static-1.3922",
  "crm-pipelines-api-client-types": "static-1.4263",
  "fdsr-migration-layer": "static-1.187",
  "framework-builder-read-service-client": "static-1.4131",
  "framework-data-schema-quick-fetch": "static-1.6973",
  "inbound-db-meta-service-client": "static-1.3713",
  "multi-currency-client-types": "static-1.3817",
  "persist-promise": "static-1.3875",
  "foundations-components-test-utils": "static-1.5757",
  "reactive-lib": "static-1.898",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.509",
  "universal-page-editor-lib": "static-1.3186",
  "adobe-sign-auth-lib": "static-1.196",
  "ads-unified-auth-lib": "static-1.686",
  "google-sheets-integration-lib": "static-1.762",
  "microsoft-drive-integration-lib": "static-1.878",
  "surveymonkey-integration-lib": "static-1.212",
  "slack-ui-library": "static-1.10570",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3903",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15416",
  "simple-menus-lib": "static-1.16933",
  "crm-record-cards-service-types": "static-1.3710",
  "location-customization-utils-lib": "static-1.9775",
  "react-flip-move": "static-1.74"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30606",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.55062",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8196",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11649",
  "I18n": "/I18n/static-7.1645",
  "quartz": "/quartz/static-1.7261",
  "quartz-config": "/quartz-config/static-1.1039",
  "quartz-core": "/quartz-core/static-1.6480",
  "react-dlb": "/react-dlb/static-1.83",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reselect": "/reselect/static-3.8",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.842",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55049",
  "feedback-utils": "/feedback-utils/static-1.55053",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4637",
  "forms-utils-lib": "/forms-utils-lib/static-1.12902",
  "foundations-assets": "/foundations-assets/static-1.5047",
  "foundations-components": "/foundations-components/static-1.8274",
  "foundations-theming": "/foundations-theming/static-1.4612",
  "hub-http": "/hub-http/static-1.6393",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyle": "/HubStyle/static-2.11956",
  "icons": "/icons/static-2.665",
  "immutable": "/immutable/static-2.79",
  "quick-fetch": "/quick-fetch/static-1.4042",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.189",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16874",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-utils": "/react-utils/static-2.5466",
  "react-virtualized": "/react-virtualized/static-2.102",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.491",
  "tinymce-plugins": "/tinymce-plugins/static-1.57954",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1205",
  "UIComponents": "/UIComponents/static-3.8595",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3525",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3538",
  "quartz-webpack": "/quartz-webpack/static-1.3485",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2328",
  "property-description-translator": "/property-description-translator/static-1.4011",
  "HeadJS": "/HeadJS/static-2.777",
  "framer-motion": "/framer-motion/static-1.75",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3307",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.225",
  "moment-timezone": "/moment-timezone/static-5.86",
  "jasmine": "/jasmine/static-4.4497",
  "jasmine-runner": "/jasmine-runner/static-1.6629",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.852",
  "hubspotter-http": "/hubspotter-http/static-1.4776",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.551",
  "module-federation": "/module-federation/static-1.29",
  "quartz-auth": "/quartz-auth/static-1.936",
  "quartz-head": "/quartz-head/static-1.926",
  "quartz-i18n": "/quartz-i18n/static-1.936",
  "quartz-routing": "/quartz-routing/static-1.691",
  "quartz-test": "/quartz-test/static-1.936",
  "quartz-tracking": "/quartz-tracking/static-1.640",
  "trellis-components": "/trellis-components/static-1.2300",
  "ui-fonts": "/ui-fonts/static-1.911",
  "usage-tracker-container": "/usage-tracker-container/static-1.7515",
  "usage-tracker-core": "/usage-tracker-core/static-1.7375",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.159",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7422",
  "reference-resolvers": "/reference-resolvers/static-1.8349",
  "sanitize-text": "/sanitize-text/static-1.8319",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10538",
  "sanitize": "/sanitize/static-1.4651",
  "outpost": "/outpost/static-1.4342",
  "rpc-client-utils": "/rpc-client-utils/static-1.4831",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4543",
  "floating-ui": "/floating-ui/static-1.60",
  "hs-story-utils": "/hs-story-utils/static-1.9599",
  "react-aria": "/react-aria/static-1.69",
  "react-create-root-preference": "/react-create-root-preference/static-1.45",
  "tanstack-table": "/tanstack-table/static-1.58",
  "trellis-assets": "/trellis-assets/static-1.2281",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3095",
  "foundations-theming-base": "/foundations-theming-base/static-1.3597",
  "stylex": "/stylex/static-1.37",
  "hs-locale-management": "/hs-locale-management/static-1.206",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.9",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9400",
  "atom": "/atom/static-1.5249",
  "codemirror": "/codemirror/static-5.98",
  "content-assistance-lib": "/content-assistance-lib/static-1.8021",
  "ContentUtils": "/ContentUtils/static-1.68884",
  "data-token-picker": "/data-token-picker/static-1.16716",
  "file-manager-components": "/file-manager-components/static-1.24137",
  "FileManagerCore": "/FileManagerCore/static-1.39636",
  "FileManagerLib": "/FileManagerLib/static-1.39777",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8101",
  "hub-http-contrib": "/hub-http-contrib/static-1.3216",
  "interframe": "/interframe/static-3.4929",
  "layout-dnd-components": "/layout-dnd-components/static-1.12781",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11756",
  "property-translator": "/property-translator/static-1.5567",
  "react-codemirror": "/react-codemirror/static-1.10807",
  "react-colorpicker": "/react-colorpicker/static-2.10381",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8270",
  "rich-text-lib": "/rich-text-lib/static-1.20134",
  "tinymce-data": "/tinymce-data/static-1.40925",
  "tinymce-themes": "/tinymce-themes/static-1.56810",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10057",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5386",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15925",
  "bender-build-tools": "/bender-build-tools/static-1.3308",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10395",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10393",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5211",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "trellis-theming": "/trellis-theming/static-1.1122",
  "tanstack-virtual": "/tanstack-virtual/static-1.33",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.241",
  "chirp-fetch": "/chirp-fetch/static-1.2061",
  "chatspot-core": "/chatspot-core/static-1.22193",
  "copilot-toolkit": "/copilot-toolkit/static-1.11585",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13203",
  "data-fetching-client": "/data-fetching-client/static-1.9832",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4932",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8879",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29054",
  "usage-tracker": "/usage-tracker/static-1.7525",
  "cms-field-types": "/cms-field-types/static-1.4988",
  "content-icons-ui": "/content-icons-ui/static-1.2278",
  "integrations-lib": "/integrations-lib/static-1.16714",
  "customer-data-objects": "/customer-data-objects/static-1.7853",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1347",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4825",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.89",
  "graphql": "/graphql/static-1.85",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4322",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9248",
  "video-components-external": "/video-components-external/static-1.11857",
  "video-data-lib": "/video-data-lib/static-1.35515",
  "audio-components": "/audio-components/static-1.6176",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29623",
  "FileManagerImages": "/FileManagerImages/static-1.37288",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1299",
  "html-to-image": "/html-to-image/static-1.57",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "salesImages": "/salesImages/static-1.529",
  "ui-universal-auth": "/ui-universal-auth/static-1.9183",
  "urlinator": "/urlinator/static-1.4705",
  "video-components": "/video-components/static-1.13859",
  "video-embed": "/video-embed/static-1.36349",
  "ts-schema": "/ts-schema/static-1.4205",
  "ContentData": "/ContentData/static-1.68959",
  "layout-data-lib": "/layout-data-lib/static-1.10081",
  "react-dnd-compat": "/react-dnd-compat/static-1.4788",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1718",
  "external-options-client-types": "/external-options-client-types/static-1.4251",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7068",
  "hs-promise-utils": "/hs-promise-utils/static-1.5767",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3971",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9176",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3236",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11322",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5667",
  "magpie-types": "/magpie-types/static-1.5127",
  "simple-logging-lib": "/simple-logging-lib/static-1.3223",
  "avatar-components": "/avatar-components/static-1.2672",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9998",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6753",
  "flux-actions": "/flux-actions/static-1.352",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5050",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14129",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5781",
  "laboratory-lib": "/laboratory-lib/static-3.7325",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7954",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10435",
  "unified-auth": "/unified-auth/static-1.697",
  "breeze-engine-core": "/breeze-engine-core/static-1.625",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.82",
  "navigation-messaging": "/navigation-messaging/static-1.7820",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12885",
  "content-media-compositions": "/content-media-compositions/static-2.16892",
  "idb-keyval": "/idb-keyval/static-1.47",
  "media-bridge-lib": "/media-bridge-lib/static-1.19230",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.979",
  "social-insights-client-types": "/social-insights-client-types/static-1.22541",
  "advanced-menus-core": "/advanced-menus-core/static-1.15417",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12314",
  "ExportDialog": "/ExportDialog/static-6.10552",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34529",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3922",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4263",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.187",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4131",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6973",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3713",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3817",
  "persist-promise": "/persist-promise/static-1.3875",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5757",
  "reactive-lib": "/reactive-lib/static-1.898",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.509",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3186",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.196",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.686",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.762",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.878",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.212",
  "slack-ui-library": "/slack-ui-library/static-1.10570",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3903",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15416",
  "simple-menus-lib": "/simple-menus-lib/static-1.16933",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3710",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9775",
  "react-flip-move": "/react-flip-move/static-1.74"
}
};
